import { render } from "./SideBar.vue?vue&type=template&id=60d010ae&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=60d010ae&scoped=true&lang=css"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d010ae"]])

export default __exports__